const STORAGE_KEY = 'studentName-vuejs'
export default {
	fetch: function() {
		return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)
		 || '[]')
	},
	save:function(items) {
		window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items))
	}
}



// WEBPACK FOOTER //
// ./src/localstorage.js